import { PropsWithChildren } from "react";

import { ClientFileApi } from "./ClientFileApi";
import { ClientFileApiContext } from "./ClientFileApiContext";

export function ClientFileApiProvider({ api, children }: PropsWithChildren<{ api: ClientFileApi }>) {
  return <ClientFileApiContext.Provider value={api}>{children}</ClientFileApiContext.Provider>;
}
